import { useModal } from '../modal';

function ModalButton({
  id,
  modalComponent, // component to render inside the modal
  buttonText, // text of the button that opens the modal
  className,
  onButtonClick, // optional: callback function that will be called once the button that opens the modal is clicked
  onModalClose, // optional: callback function that will be called once the modal is closed
  title, // optional
  type, // optional
  disabled, // optional
  ...buttonProps
}) {
  const { setModalContent, setOnModalClose } = useModal();

  const onClick = () => {
    if (disabled) return;
    if (onModalClose) setOnModalClose(onModalClose);
    setModalContent(modalComponent);
    if (onButtonClick) onButtonClick();
  };

  return (
    <button
      id={id}
      title={title}
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      {...buttonProps}
    >
      {buttonText}
    </button>
  );
}

export default ModalButton;